import Store from '@/classes/Store'
import PricedCar from '@/classes/PricedCar'
import { isNullish } from 'typechecker'

/**
 * 「店家」和「車輛列表」的組合。通常用在店家和該店家的車輛列表高度聯繫的場合，例如用於在地圖的
 *  Marker 顯示該店家最便宜價格的車。當 `store` 為 `null` 時意味著這是模糊搜尋的結果
 */
export default class StoreCars {
  /** 店家 */
  store: Store | null
  /** 車輛列表 */
  cars: PricedCar[] = []

  constructor (
    cars: PricedCar[] = [],
    store?: Store | null
  ) {
    if (isNullish(store)) {
      this.store = null
    } else if (store instanceof Store) {
      this.store = store
    } else throw new TypeError('`store` must be an instance of Store')

    if (
      Array.isArray(cars) &&
      cars.every(car => car instanceof PricedCar)
    ) this.cars = cars
  }

  /** 最便宜的車輛 */
  get cheapestCar (): PricedCar | null {
    if (!this.cars.length) return null
    return [...this.cars].sort((a, b) => a.price.value - b.price.value)[0]
  }
}
